import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const AusschreibungVergabeAntragEmobInvest: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Ausschreibung und Vergabe' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0068448995_Vergabe_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0108452210_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0039580205_be_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0251802548_nd_Vergabe_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default AusschreibungVergabeAntragEmobInvest;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0251802548_nd_Vergabe_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0212189411_Des_Ausschreibungsverfahrens,
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0077437159_s_Bis_Zur_Zuschlagserteilung,
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0265738034_d_Der_Lade_Tankinfrastruktur,
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0220424306_chreibung_Und_Vergabe_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAusschreibungVergabeAntragEmobInvest = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0068448995_Vergabe_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0251802548_nd_Vergabe_Pruefung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	else return concat(formStruc());
};
